import React from 'react';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import { below } from 'utils/breakpoint';
import FormInfoButton from 'client/components/Result/EntriesInfo/form/FormInfoButton';
import { setTextVariantStyle } from 'utils/variantStyle';
import VerifyStatusLabel from 'client/components/verify/VerifyStatusLabel';

export default function SerialDateInfo({
    id,
    date,
    children,
    showFormBtn = false,
    formIds,
    entryUuid,
    validStatus,
    shouldShowStatusLabel = false
}) {
    return (
        <>
            <div css={listStyle}>
                <div css={leftStyle}>
                    <Typography variant="subtitle2" css={dateStyle}>
                        {date}
                    </Typography>
                    <Typography variant="caption" css={numStyle}>
                        ID: {id}
                    </Typography>
                </div>
                <div css={rightStyle}>
                    {shouldShowStatusLabel && <VerifyStatusLabel status={validStatus} />}
                    {showFormBtn && <FormInfoButton formIds={formIds} entryUuid={entryUuid} />}
                </div>
            </div>

            {children}
        </>
    );
}

const listStyle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    gap: 8px;
    > * {
        color: inherit;
    }
`;

const numStyle = css`
    ${setTextVariantStyle('caption')}
    padding-right: 8px;
    ${below('sm')} {
        padding-right: 4px;
    }
`;

const dateStyle = css`
    ${setTextVariantStyle('subtitle2')}
    @media only screen and (max-width: 380px) {
        display: inline-block;
    }
`;

const leftStyle = css`
    display: flex;
    flex-direction: column;
`;

const rightStyle = css`
    display: flex;
    align-items: center;
    gap: 8px;
`;
